import { colors } from "../../styles/variables";

export const SelectStyles = (isDark: boolean) => ({
  container: (provided: any, state: { isDisabled: boolean }) => ({
    ...provided,
    pointerEvents: state.isDisabled ? null : null,
  }),
  control: (provided: any, state: { isDisabled: boolean }) => ({
    ...provided,
    ...(isDark
      ? {
          borderColor: "#30353F",
          backgroundColor: "#111",
          "&:hover": {
            borderColor: "#30353F",
          },
        }
      : {
          borderColor: colors.steam,
          backgroundColor: state.isDisabled ? "#FBFBFB" : colors.steam,
          "&:hover": {
            borderColor: colors.gold,
          },
        }),
    boxShadow: "none",
    borderRadius: "0px",
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    borderWidth: "1px",
    paddingLeft: "24px",
    paddingRight: "24px",
    paddingTop: "16px",
    paddingBottom: "14px",
    fontSize: "16px",
    color: "red",
    textAlign: "start",
    textTransform: "uppercase",
  }),
  singleValue: (provided: any) => ({
    ...provided,
    ...(isDark
      ? {
          color: "#FFFFFF",
        }
      : {
          color: colors.gray,
        }),
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    padding: 0,
    height: "24px",
  }),
  input: (provided: any) => ({
    ...provided,
    height: "19px",
    overflow: "hidden",
  }),
  placeholder: (provided: any, state: { isDisabled: boolean }) => ({
    ...provided,
    ...(isDark
      ? {
          color: "#FFFFFF",
        }
      : {
          color: state.isDisabled ? "#BFBFBF;" : colors.purple,
        }),
    fontSize: "16px",
    lineHeight: "24px",
  }),
  option: (provided: any) => ({
    ...provided,
    backgroundColor: colors.white,
    color: colors.petricite,
    fontSize: "16px",
    lineHeight: "24px",
    paddingLeft: "24px",
    textAlign: "start",
    textTransform: "uppercase",

    "&:hover": {
      color: "white",
      backgroundColor: colors.purple,
      cursor: "pointer",
    },
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    ...(isDark
      ? {
          color: colors.gray,
        }
      : {
          color: colors.gray,
        }),
    padding: "0px",
    svg: {
      width: "18px",
      height: "18px",
    },
  }),
  indicatorSeparator: (base: any) => ({
    ...base,
    display: "none",
  }),
  menu: (base: any) => ({
    ...base,
    backgroundColor: colors.steam,
    borderRadius: "0px",
    marginTop: "4px",
  }),
});
